import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Candidatos } from 'src/app/interfaces/candidatos';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { InicioService } from 'src/app/services/inicio/inicio.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-candidate-featured',
  templateUrl: './candidate-featured.component.html',
  styleUrls: ['./candidate-featured.component.scss']
})
export class CandidateFeaturedComponent implements OnInit {

  usuario: JwtResponse;
  usuarioRol: string;
  candidatosDestacados: Candidatos[];
  candidatoslenght: number;
  verArchivos: string;

  constructor(private inicioService: InicioService, private router: Router) {
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    this.usuarioRol = '';
    this.verArchivos = environment.baseArchivos;
   }

  ngOnInit() {
    if(this.usuario){
        this.usuarioRol = this.usuario.role;
    }

    this.obtenerCandidatosDestacados();
  }

  async obtenerCandidatosDestacados(){
    try {
        const response = await this.inicioService.obtenerCandidatosDestacados();
        this.candidatosDestacados = response.data;
        this.candidatoslenght = this.candidatosDestacados.length;
        if(this.candidatosDestacados){
            this.candidatosDestacados.forEach(candidato =>
            candidato.imagen = (candidato.imagen != environment.candidatoDefault ? this.verArchivos + candidato.imagen : candidato.imagen));
          }
    } catch (error) {
        console.error("Error al traer candidatos destacados", error);
    }
  }

  seleccionarIdCandidato(idCandidato:number){
    if(this.usuarioRol){
        this.router.navigate(['candidatos/detalles/'+idCandidato]);
    }else{
        this.router.navigate(['acceder']);
    }
  }

    getImagenWidth() {
        const numCandidatos = this.candidatosDestacados.length;
        return numCandidatos === 1 ? '22%' : '65%';
    }

  optionsSlides: OwlOptions = {
    loop: true,
    nav: true,
    dots: false,
    autoplayHoverPause: true,
    autoplay: true,
    margin: 30,
    navText: [
        "<i class='icofont-arrow-left'></i>",
        "<i class='icofont-arrow-right'></i>"
    ],
    responsive: {
        0: {
            items: 1
        },
        576: {
            items: 2
        },
        768: {
            items: 3
        },
        1200: {
            items: 4
        }
    }
}
}
